import { createContext } from "react"
import { defaultScrollPositionContextValue } from "./defaultScrollPositionContextValue"
import type { ScrollPositionContextValue } from "./ScrollPositionContextValue"

export const ScrollPositionContext = createContext<ScrollPositionContextValue>(
  defaultScrollPositionContextValue,
)
